export const PAYMENT_TYPES = {
  USD: 'USD',
  USDT: 'USDT',
} as const;
